import { Routes } from '@angular/router';

export const calcRoutes: Routes = [
  {
    path: 'calcu',
    loadComponent: () =>
      import('./calculator.component').then((c) => c.CalculatorComponent),
  },
  {
    // Redirect old acumulative route to unified calculator
    path: 'calculadora-acumulativa',
    redirectTo: 'calcu',
    pathMatch: 'full',
  },
];
